/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import AlphaBoxContentComponent from './AlphaBoxContentComponent';
import AutoSuggestComponent from '../AutoSuggestComponent';
import DataBoxSuggestionComponent from '../databox/DataBoxSuggestionComponent';

class AlphaBoxComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
    };

    this.getSuggestions = this.getSuggestions.bind(this);
  }

  componentDidMount() {
    const { box } = this.props;
    const { data } = box;
    if (data.mode === 'json' && data.source !== '') {
      if (data.itemsOnly) {
        data.source += '?itemsOnly=true';
      }
      axios.get(data.source).then((promise) => {
        const { data: pData } = promise;
        this.setState({ items: pData.items });
      });
    }
  }

  getSuggestions(value, _, callback) {
    const { items } = this.state;
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    callback(inputLength < 2 ? []
      : items.filter(
        (x) => x.name.toLowerCase().indexOf(inputValue) > -1
          || x.name.replace(/-/ig, ' ').toLowerCase().indexOf(inputValue) > -1
          || x.name.replace(/ /ig, '-').toLowerCase().indexOf(inputValue) > -1,
      )
        .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'da', { ignorePunctuation: true })));
  }

  render() {
    const { box } = this.props;
    const { items } = this.state;
    const { config } = box;
    const renderLinks = config.links.map((l) => (
      <li key={l.title}>
        <a
          href={l.url}
          onClick={() => {
            if (typeof l.onClick === 'function') {
              l.onClick();
            }
          }}
          style={{ backgroundColor: box.background.linkColor }}
        >
          {l.title}
        </a>
      </li>
    ));

    return (
      <div className="au_alphabox" style={{ backgroundColor: box.background.color }}>
        <div>
          <h2>
            <a href={config.url}>{config.title}</a>
          </h2>
          <AlphaBoxContentComponent
            items={items}
            linkColor={box.background.linkColor}
            noResultsText={config.noResultsAlphabet}
            noResultsUri={config.noResultsUri}
          />
          <AutoSuggestComponent
            placeholder={box.search.placeHolder}
            setResults={(_items) => {
              if (_items.length >= 1 && _items[0].url) {
                window.location.href = _items[0].url;
              }
            }}
            collection={[]}
            getSuggestions={this.getSuggestions}
            getSuggestionValue={(suggestion) => suggestion.name}
            renderSuggestion={(suggestion) => <DataBoxSuggestionComponent item={suggestion} />}
            noResultsText={config.noResultsSearch}
          />
          {
            config.description !== '' && (
              <h3>{config.description}</h3>
            )
          }
          {
            config.links.length > 0 && (
              <ul className="quicklinks resetlist">
                {renderLinks}
              </ul>
            )
          }
        </div>
      </div>
    );
  }
}

AlphaBoxComponent.propTypes = {
  box: PropTypes.shape({
    id: PropTypes.number.isRequired,
    data: PropTypes.shape({
      itemsOnly: PropTypes.bool.isRequired,
      mode: PropTypes.string.isRequired,
      source: PropTypes.string.isRequired,
    }),
    config: PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      container: PropTypes.string.isRequired,
      tracking: PropTypes.string.isRequired,
      links: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })).isRequired,
      title: PropTypes.string.isRequired,
      noResultsAlphabet: PropTypes.string.isRequired,
      noResultsSearch: PropTypes.string.isRequired,
      noResultsUri: PropTypes.string.isRequired,
    }).isRequired,
    background: PropTypes.shape({
      color: PropTypes.string.isRequired,
      linkColor: PropTypes.string.isRequired,
    }).isRequired,
    search: PropTypes.shape({
      placeHolder: PropTypes.string.isRequired,
      minLength: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

AlphaBoxComponent.displayName = 'AlphaBoxComponent';
export default AlphaBoxComponent;
